export const GA_SCROLL_COLLECTIONS_ACTION = 'ScrollCollections';
export const GA_CLICK_VIEW_COLLECTION_ACTION = 'ViewEditorialCollection';
export const GA_VIEW_NEXT_ACTION = 'CollectionsViewNext';
export const GA_VIEW_PREVIOUS_ACTION = 'CollectionsViewPrevious';
export const GA_EDITORIAL_COLLECTION_CATEGORY = 'editorial-collection-carousel';
